export default "__VITE_ASSET__S458xs_P__"